<template>
  <Charts 
    v-if="showFlag"
    @chartInit="chartInit"
  ></Charts>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import Charts from '@/components/Charts';

// props
const props = defineProps({
  dataList: {
    type: Array,
  },
  showFlag: { type: Boolean, defalut: false, },
});
// emit
const emit = defineEmits([
  
]);

let chart;
const chartInit = (e)=>{
  chart = e;
  nextTick(()=>{
    chartUpdate(props.dataList);
  })
}
const data = computed(()=> props.dataList)
watch(data, (newd, old)=>{
  chartUpdate(newd);
}, {
  deep: true, 
})

const chartUpdate = (list)=>{
  if(!chart)return;
  chart.clear();
  chart.setOption(getOptions(list));
}

const getOptions = (list)=>{
  // 计算去重后的 count
  function getDeduplicatedCount(exposureList) {
    if (!exposureList || exposureList.length === 0) return 0;
    const unique = new Set(
      exposureList.map(item => `${item.scanProductTime}_${item.scanSatelliteType}`)
    );
    return unique.size;
  }
  return {
    // title: {
    //   text: `${ target.roiName || target.regionName || ''}\r点位聚焦频次`,
    //   textStyle: {
    //     color: 'rgba(227, 246, 245, 1)',
    //     fontFamily: 'OPPOSans-M',
    //     fontWeight: 700,
    //   },
    //   // textAlign: 'center',
    //   subtext: `${ data.at(0).st }\r~\r${ data.at(-1).et }`,
    //   subtextStyle: {
    //     color: 'rgba(227, 246, 245, 1)',
    //     fontFamily: 'OPPOSans',
    //     fontWeight: 400,
    //   }
    // },
    // toolbox: {
    //   feature: {
    //     mySave: {
    //       show: true,
    //       title: '保存记录',
    //       // icon: 'image://'+require('@/assets/icon/echarts/symbols-save.png'),
    //       icon: 'image://data:image/svg+xml;base64,'+ exportBrowseIcon,
    //       onclick: ()=> {
    //         saveChartsFn();
    //       },
    //       iconStyle: {
    //         color: '#fff',
    //       }
    //     },
    //     myClose: {
    //       show: true,
    //       title: '关闭',
    //       // icon: 'image://'+require('@/assets/icon/echarts/symbols-close.png'),
    //       icon: 'image://data:image/svg+xml;base64,'+ circleCloseIcon,
    //       onclick: ()=> {
    //         chartShowFlag.value = false;
    //       },
    //       iconStyle: {
    //         color: '#fff',
    //       }
    //     },
    //   }
    // },
    grid: {
      left: '3%',    // 左侧留白百分比
      right: '3%',   // 右侧留白百分比
      top: '15%',     // 顶部留白
      bottom: '20%'   // 底部留白
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow', // 阴影指示区域
        shadowStyle: {
          color: 'rgba(61, 143, 179, 0.3)' // 阴影颜色和透明度
        }
      },
      textStyle: {
        fontWeight: 'bold',
        fontFamily: 'OPPOSans-M',
      },
    },
    graphic: [{
      type: 'text',
      right: 20,
      top: 10,
      style: {
        text: `总计: ${list.reduce((acc, item) => acc + getDeduplicatedCount(item.exposureList), 0)}`,
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#112f7f',
      },
    }],
    // tooltip: {
    //   trigger: 'axis',
    //   axisPointer: {
    //     type: 'shadow', // 阴影指示区域
    //     shadowStyle: {
    //       color: 'rgba(61, 143, 179, 0.3)' // 阴影颜色和透明度
    //     }
    //   },
    //   formatter: (lineData)=>{
    //     let str = '';
    //     lineData.forEach((chart, index, array)=>{
    //       const item = chart.data.target;
    //       const date = item.year?item.year+'-'+item.date:item.date;
    //       str+=`${chart.marker}\n\n${date}\n\n${item.num}`;
    //       if(array.length !=index){
    //         str+='<br />';
    //       }
    //     })
    //     return str;
    //   },
    //   textStyle: {
    //     fontWeight: 'bold',
    //     fontFamily: 'OPPOSans-M',
    //   },
    // },
    xAxis: {
      type: 'category',
      data: list.map(e=>{ return e.exposureTime; }),
      nameLocation: 'center',
      axisLabel: {
        // interval: 0,
        color: 'rgb(133, 133, 133)',
        formatter: (value, index)=>{
          const arr = value.split('-');
          if(arr.length == 3){
            return `{monthDay| ${arr.at(1)}${arr.at(2)}}\n{year| ${arr.at(0)}}`;
          }else if(arr.length == 2){
            return `{monthDay| ${arr.at(1)}}\n{year| ${arr.at(0)}}`
          }else{
            return value;
          }
        },
        fontFamily: 'OPPOSans-M',
        rich:{
          year: {
            fontSize: '12px',
          },
          monthDay: {
            fontSize: '14px',
          }
        },
        align: 'center',    // 水平居中
      },
      axisLine: {
        lineStyle: {
          width: 3,
        }
      },
      axisTick: {
        show: false,
      }
    },
    yAxis: {
      type: 'value',
      show: false,
      minInterval: 1,
      splitLine: {
        show: false,
      }
    },
    series: [
      {
        smooth: true,
        symbol: 'circle',
        symbolSize: 10,
        itemStyle: {
          borderWidth: 0 // 边框宽度（可选）
        },
        data: list.map((e)=>{
          const count = getDeduplicatedCount(e.exposureList);
          return {
            target: e,
            value: count,
            itemStyle: {
              // color: e.num == maxNum || e.num == minNum?'rgba(255, 71, 42, 1)':circleColors[index], // 实心点颜色
              color: 'rgb(17, 47, 127)', // 实心点颜色
            },
            // dataItem: target
          };
        }),
        type: 'line',
        lineStyle: {
          color: 'rgb(17, 47, 127)',
        },
        label: {  // 显示数据标签
          show: true,  // 开启显示
          position: 'top',  // 位置：'top', 'bottom', 'left', 'right'
          formatter: '{c}', // 显示数据值，{c}表示数据值
          // color: 'rgba(227, 246, 245, 1)',
          color: 'rgb(17, 47, 127)',
        }
      }
    ],
  }
}

const chartDownloadFn = (name)=>{
  // console.log(chart);
  const picInfo = chart.getDataURL({
    type: 'png',
    pixelRatio: 1.5,
    backgroundColor: '#fff'
  });
  
  const elink = document.createElement('a');
  elink.download = name || 'chart';
  elink.href = picInfo;
  elink.click();
}

defineExpose({
  chartDownloadFn,
})

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>